import React from 'react';

const TRIAL_INFO = 'One-time free trial credits. Available until fully used or until you subscribe to a plan.';

const CLASSES = {
  page: {
    box: 'rounded-xl bg-surface-elevated border border-border px-3 py-2',
    row: 'flex items-center justify-between gap-3 text-sm text-text-primary',
    icon: 'w-4 h-4 text-text-tertiary cursor-help',
    info: 'absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-surface-elevated border border-border rounded-xl shadow-lg text-[11px] text-text-secondary leading-relaxed w-48 opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto transition-opacity duration-150 z-50',
  },
  sidebar: {
    box: 'vs-trial',
    row: 'vs-trial-row',
    icon: 'vs-trial-icon',
    info: 'vs-trial-info',
  },
};

export function TrialCreditsBalance({ user, variant = 'page' }) {
  if (!user || ['active', 'canceling', 'past_due'].includes(user.subscription_status)) return null;
  const classes = CLASSES[variant];

  return (
    <div className={classes.box}>
      <div className={classes.row}>
        <div className="flex items-center gap-1.5">
          <span>Free trial credits</span>
          <div className="relative group">
            <svg className={classes.icon} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <circle cx="12" cy="12" r="10" />
              <path strokeLinecap="round" d="M12 16v-4m0-4h.01" />
            </svg>
            <div className={classes.info}>
              {TRIAL_INFO}
            </div>
          </div>
        </div>
        <span className="font-semibold tabular-nums">{user.available_trial_credits || 0} / 10</span>
      </div>
    </div>
  );
}
